import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { ContainerBase } from './containerBase';

// Generic vertical layout
const LeftSidebarLayoutOuter = styled.div`
    display: flex;
    gap: 24px;
    position: relative;
`;

const LeftSidebarLayoutInner = styled(ContainerBase)`
    flex: 1;
`;

export type SidebarItemIdType = string | number;

export interface SidebarItem<T extends SidebarItemIdType = string> {
    id: T;
    label: string;
    selected?: boolean;
    disabled?: boolean;
    subItems?: SidebarItem<T>[];
    buttons?: SidebarButton[];
    position?: number;
}

export interface SidebarButton {
    key: string;
    tooltip?: string;
    icon: React.ReactElement<React.SVGAttributes<SVGElement>>;
    isActive?: boolean;
    id?: string;
}

interface LeftSidebarLayoutProps {
    sidebar?: React.ReactNode;
}

export const LeftSidebarLayout = ({ children, sidebar }: PropsWithChildren<LeftSidebarLayoutProps>) => {
    return (
        <LeftSidebarLayoutOuter>
            {sidebar}
            <LeftSidebarLayoutInner>{children}</LeftSidebarLayoutInner>
        </LeftSidebarLayoutOuter>
    );
};
